<template>
  <div class="content">
    <!-- 添加用户的表单 -->
    <el-form ref="addFormRef" :rules="addRules" :model="params" label-width="100px">
      <el-form-item prop="project_name" label="项目名称">
        <el-input v-model.trim="params.project_name"></el-input>
      </el-form-item>
      <el-form-item label="图标">
        <el-upload class="avatar-uploader" multiple name="files" action="" :http-request="fnUploadRequest" :show-file-list="false" :on-success="handleAvatarSuccess"
          :before-upload="beforeUpload" :data="{filename: 'files'}" accept=".png,.jpg">
          <img v-if="params.img_url" :src="params.img_url" class="avatar">
          <i v-else class="el-icon-camera avatar-uploader-icon"></i>
        </el-upload>
        <div class="input-tips">
          <span>建议使用80*80像素</span>
          <span>仅支持jpg和png的格式</span>
        </div>
      </el-form-item>
      <el-form-item prop="project_desc" label="项目简介">
        <!-- <el-input type="textarea" v-model="params.project_desc"></el-input> -->
        <TinymceEditor :ref_id="`descref`" :content="params.project_desc" :editor_belong="`desc`" v-model="params.project_desc">
        </TinymceEditor>
      </el-form-item>
      <el-form-item>
        <el-button @click="addDialogClose()">取消</el-button>
        <el-button type="primary" @click="submitForm('addFormRef')">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import oss from '@/utils/aliOss';
import { saveTargetProjectTitleData } from '@/api/contest';
import TinymceEditor from "@/components/test/TinymceEditor";
export default {
  components: {
    TinymceEditor,
  },
  data() {
    const percentValid = function (rule, value, callback) {
      var errors = [];
      if (value) {
        if (!/^[0-9]+$/.test(value)) {
          callback('请输入0-100以内的正整数!');
        }
        if (value > 100) {
          callback('请输入0-100以内的正整数!');
        }
      }
      callback(errors);
    }
    return {
      params: {
        id: '',//项目id
        target_id: '',//上级目标id
        project_name: '',//项目名称
        project_desc: '',//项目简介
        img_url: '',//项目图标
        percent: '',//项目分值占比
      },
      // 验证规则
      addRules: {
        project_name: [
          { required: true, message: '请输入项目名称!', trigger: 'blur' },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value.length > 30 || !value) {
                callback('请输入1-30位字符!');
              }
              callback(errors);
            }
          }
        ],
        // project_desc:[
        // 	{required: true,message: '请输入项目简介!',trigger: 'blur'},
        // 	{validator(rule, value, callback, source, options) {
        // 			let errors = [];
        // 			if(!value.length){
        // 				callback('请输入项目简介!');
        // 			}
        // 		    callback(errors);
        // 		}
        // 	}
        // ],
        percent: [
          { validator: percentValid, trigger: 'blur' },
          { validator: percentValid, trigger: 'change' }
        ]
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('returnItems')
  },
  props: ['projectData'],
  mounted() {
    if (Object.keys(this.projectData).length > 1) {
      this.params = { ...this.projectData }
    } else {
      this.params.target_id = this.projectData.target_id
    }
  },
  methods: {
    // 关闭弹框的回调
    addDialogClose() {
      this.$emit("close");//调用父组件的删除方法
    },
    //保存项目设置
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            id: this.params.id ? this.params.id : 0,
            target_id: this.params.target_id,
            project_name: this.params.project_name,
            project_desc: this.params.project_desc,
            img_url: this.params.img_url,
            percent: Number(this.params.percent)
          }
          saveTargetProjectTitleData(params).then(response => {
            if (this.params.id) {
              let obj = params
            } else {
              let obj = response.data
            }
            this.$root.$emit('returnProject', response.data)
            this.$message.success('保存成功');
          })
        }
      });
    },
    resetForm() {
      this.$refs['addFormRef'].resetFields();
    },
    // 图片上传尺寸大小检验
    beforeUpload(file) {
      let _this = this;
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('仅支持jpg和png格式');
        return false
      }
    },
    handleAvatarSuccess(res, file) {
      if (!res) return
      this.params.img_url = res.res.requestUrls[0].split('?')[0];
    },
    /**
    * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
    * @param    {object}   option [上传选项]
    * @return   {null}   [没有返回]
    */
    async fnUploadRequest(option) {
      oss.ossUploadFile(option, 1)
    },
  },
  computed: {
    validating() {
      return this.$parent.validateState === 'validating';
    }
  },
};
</script>

<style scoped="">
</style>